import React from 'react';
import Navbar from '../global-components/navbar';
import PageHeader from '../global-components/page-header';
import PopularPost from '../blog-components/popular-post';
import PostList from '../blog-components/post-list';
import Footer from '../global-components/footer';
import BlogHeader from '../global-components/Blog-Header';
import GetInTouch from '../../utils/getInTouch';
import BlogContact from '../../utils/blogContact';
import Faqs from '../section-components/faq';

const Blog = () => {
    return <div>
        <Navbar />
        {/* <PageHeader headertitle="Blogs " subheader="Blogs" /> */}
         <BlogHeader headertitle="Blogs " subheader="Blogs"/>
        {/* <PopularPost /> */}
        <PostList />
        <BlogContact />
        <Faqs />
        <Footer />
    </div>
}

export default Blog